







import { defineComponent, PropType } from "@vue/composition-api";
import { CreatorServiceTag } from "../types";

export default defineComponent({
  name: "CreatorServiceTag",
  props: {
    item: { type: Object as PropType<CreatorServiceTag>, required: true },
  },
});
